{
  "de": {
    "surveys": {
      "buttons": {
        "addAnswer": "Option hinzufügen",
        "edit": "Klicken zum Bearbeiten",
        "moveQuestionDown": "Frage nach unten verschieben",
        "moveQuestionUp": "Frage nach oben verschieben",
        "removeOption": "Option entfernen",
        "removeQuestion": "Frage entfernen"
      },
      "confirm": {
        "deleteQuestionText": "Diese Aktion kann nicht rückgängig gemacht werden. Die Frage wird mit allen Antwortoptionen dauerhaft aus der Umfrage entfernt.",
        "deleteQuestionTitle": "Frage löschen?",
        "requiredIncompleteText": "Du hast noch nicht alle Pflichtfelder (mit *) ausgefüllt. Ergänze sie, um die Umfrage abzuschicken.",
        "requiredIncompleteTitle": "Pflichtfelder fehlen",
        "submitIncompleteText": "Du hast noch nicht alle Fragen beantwortet. Deine Antwort wird trotzdem abgeschickt.",
        "submitIncompleteTitle": "Antwort abschicken?"
      },
      "flash": {
        "questionAdded": "Frage hinzugefügt",
        "questionDeleted": "Frage gelöscht",
        "questionMoved": "Frage verschoben",
        "questionUpdated": "Frage aktualisiert",
        "submitFailed": "Deine Antwort konnte nicht abgeschickt werden. Bitte versuche es erneut."
      },
      "headers": {
        "answers": "Ergebnisse",
        "general": "Titel und Beschreibung",
        "lastAnswered": "Zuletzt beantwortet",
        "questions": "Fragen",
        "responsesPerQuestion": {
          "answers": "{count} Antwort | {count} Antworten",
          "oClock": "Uhr",
          "of": "bei",
          "responses": "{count} Abgabe | {count} Abgaben"
        },
        "shareResultsLink": "Teile diesen Link zu den Ergebnissen der Umfrage"
      },
      "hints": {
        "average": "Durchschnitt",
        "evaluations": "{count} Bewertung | {count} Bewertungen",
        "file": "Formuliere einen Arbeitsauftrag, für den deine Schüler*innen eine Datei hochladen sollen (z. B. eine Textdatei, ein Bild oder eine PDF).",
        "long_answer": "Verfasse einen Arbeitsauftrag, für den deine Schüler*innen eine Antwort in einem Textfeld digital einreichen können.",
        "maxOptionsReached": "Maximal {max} Optionen können hinzugefügt werden.",
        "multiple_choice": "Stelle eine Frage und trage die Antwortmöglichkeiten ein. Mehr als eine Antwort kann ausgewählt werden.",
        "noDescriptionOrOptions": "Keine Beschreibung oder Optionen hinterlegt",
        "notAnswered": "keine Angabe",
        "rating": "Lasse deine Schüler*innen etwas mit 1-5 Sternen bewerten.",
        "required": "Frage muss beantwortet werden",
        "single_choice": "Stelle eine Frage und trage die Antwortmöglichkeiten ein. Nur eine Antwort kann ausgewählt werden.",
        "submitSuccessful": "Danke fürs Teilnehmen an dieser Umfrage."
      },
      "inserter": {
        "title": "Neuen Block hinzufügen"
      },
      "labels": {
        "backToResponseIndex": "Zurück zur Übersicht",
        "loadingResponses": "Antworten werden geladen...",
        "required": "Pflichtfeld",
        "showAllAnswers": "Details anzeigen"
      },
      "placeholders": {
        "description": "Beschreibung hinzufügen",
        "optionInput": "Option hier eingeben...",
        "question": "Frage",
        "title": "Titel hier eingeben..."
      },
      "questionTypes": {
        "file": "Datei Anfordern",
        "long_answer": "Textantwort",
        "multiple_choice": "Multiple Choice",
        "net_promoter_score": "Net Promoter Score (0-10)",
        "rating": "Bewertung",
        "single_choice": "Single Choice"
      },
      "tabs": {
        "submissions": "Abgaben",
        "survey": "Umfrage"
      }
    }
  }
}
